import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import { useResponsiveProps } from 'ecosystem-marketplace-core/hooks/useResponsiveProps';
/* @ts-expect-error module is untyped */

import LoadingWrapper from 'ecosystem-marketplace-core/components/LoadingWrapper';
import RouterThemeCard from './RouterThemeCard';
import StorefrontResultsSection from './StorefrontResultsSection';
import { searchThemes } from '../../../clients/ecosystemClient';

const SectionLoadingComponent = () => {
  return /*#__PURE__*/_jsx(UILoadingSpinner, {
    minHeight: 150,
    layout: "centered"
  });
};

const ErrorComponent = () => {
  return /*#__PURE__*/_jsx(UIAlert, {
    type: "danger",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-assets-ui.themes.details.recommendations.error"
    })
  });
};

const ResultComponent = ({
  index,
  result,
  resultsLength,
  trackInteraction,
  trackPageview
}) => {
  return /*#__PURE__*/_jsx(RouterThemeCard, {
    onClick: () => {
      trackInteraction('click result item', {
        value: result.slug,
        itemIndex: index,
        totalResults: resultsLength
      });
    },
    onTrackInteraction: trackInteraction,
    onTrackPageview: trackPageview,
    result: result,
    view: "grid"
  });
};

const ThemeResultsSectionDataContainer = (_ref) => {
  let {
    maxColumns,
    offeringId,
    responsive,
    searchQuery
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["maxColumns", "offeringId", "responsive", "searchQuery"]);

  const [requestState, setRequestState] = useState(RequestStates.UNINITIALIZED);
  const [searchResponse, setSearchResponse] = useState(null);
  useEffect(() => {
    if (requestState === RequestStates.UNINITIALIZED) {
      setRequestState(RequestStates.PENDING);
      const request = Promise.resolve(searchQuery).then(query => searchThemes([query]));
      request.then(([resp]) => {
        setSearchResponse(resp);
        setRequestState(RequestStates.SUCCEEDED);
      }).catch(error => {
        console.error('error fetching collection\n', error);
        setSearchResponse(null);
        setRequestState(RequestStates.FAILED);
      });
    }
  }, [searchQuery, requestState]);
  const {
    mobileResultsSize
  } = useResponsiveProps({
    mobileResultsSize: {
      xs: 2,
      md: maxColumns
    }
  });
  const totalResultsSize = useMemo(() => {
    return responsive ? mobileResultsSize : maxColumns;
  }, [mobileResultsSize, maxColumns, responsive]);
  const displayedResults = useMemo(() => {
    const results = searchResponse ? searchResponse.items : [];

    if (offeringId) {
      const filteredResults = results.filter(result => result.offeringId !== offeringId);

      if (totalResultsSize && filteredResults.length > totalResultsSize) {
        return filteredResults.slice(0, totalResultsSize);
      }

      return filteredResults;
    }

    return results;
  }, [offeringId, searchResponse, totalResultsSize]);

  if (displayedResults.length < 1) {
    return null;
  }

  return /*#__PURE__*/_jsx(LoadingWrapper, {
    ErrorComponent: ErrorComponent,
    LoadingComponent: SectionLoadingComponent,
    requestStatus: requestState,
    children: /*#__PURE__*/_jsx(StorefrontResultsSection, Object.assign({}, rest, {
      results: displayedResults,
      ResultComponent: ResultComponent
    }))
  });
};

export default ThemeResultsSectionDataContainer;